import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useLanguage } from '../i18n';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';

const FaqItem = ({ item, index, open, onToggle }) => (
  <div className="border-b border-graphite-200" data-testid={`faq-item-${index + 1}`}>
    <button
      type="button"
      onClick={onToggle}
      data-testid={`faq-question-${index + 1}`}
      aria-expanded={open}
      className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-200 hover:text-silver-glow"
    >
      <span className={`text-lg font-medium tracking-tight ${open ? 'text-silver' : 'text-steel-bright'}`}>
        {item.q}
      </span>
      <Plus
        size={20}
        className={`shrink-0 text-steel-label transition-transform duration-300 ${open ? 'rotate-[135deg]' : ''}`}
      />
    </button>
    <div
      className={`grid transition-[grid-template-rows] duration-300 ease-out ${
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      }`}
    >
      <div className="overflow-hidden">
        <p className="max-w-2xl pb-6 text-sm leading-relaxed text-steel" data-testid={`faq-answer-${index + 1}`}>
          {item.a}
        </p>
      </div>
    </div>
  </div>
);

const Faq = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div data-testid="faq-page" className="pt-16">
      <section>
        <div className="mx-auto max-w-7xl px-6 py-24">
          <PageHero overline={t.faq.overline} title={t.faq.title} titleClassName="" />

          <div className="mt-16 grid gap-12 md:grid-cols-12">
            <div className="md:col-span-8 md:col-start-4" data-testid="faq-accordion">
              {t.faq.items.map((item, i) => (
                <FaqItem
                  key={i}
                  item={item}
                  index={i}
                  open={openIndex === i}
                  onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Faq;
